'use client';
import { Roboto } from 'next/font/google';
import { createTheme,  alpha, getContrastRatio } from '@mui/material/styles';

const roboto = Roboto({
  weight: ['300', '400', '500', '700'],
  subsets: ['latin'],
  display: 'swap',
});


const theme = createTheme({
  typography: {
    fontFamily: roboto.style.fontFamily,
  },
  palette: {
    //primary: {main: '#6ac476ff'},
    ochre: {
        main: '#E3D026',
        light: '#E9DB5D',
        dark: '#A29415',
        contrastText: '#242105',
    },
    violet: {
        main: alpha('#7F00FF', 0.7),
        light: alpha('#7F00FF', 0.5),
        dark: alpha('#7F00FF', 0.9),
        contrastText: getContrastRatio(alpha('#7F00FF', 0.7), '#fff') > 4.5 ? '#fff' : '#111',
    },
    orange: {
        main: '#ED6C02',
        light: alpha('#ED6C02', 0.5),
        dark: alpha('#ED6C02', 0.9),
        contrastText: getContrastRatio('#ED6C02', '#fff') > 1.5 ? '#fff' : '#111',
    },
    yellow: {
        main: '#e4c45dff',
        light: alpha('#e4c45dff', 0.5),
        dark: alpha('#e4c45dff', 0.9),
        contrastText: getContrastRatio('#e4c45dff', '#fff') > 4.5 ? '#fff' : '#111',
    },
    red: {
        main: '#c22d2dff',
        light: alpha('#c22d2dff', 0.5),
        dark: alpha('#c22d2dff', 0.9),
        contrastText: getContrastRatio('#c22d2dff', '#fff') > 4.5 ? '#fff' : '#111',
    },
    green: {
        main: alpha('#2E7D32', 0.7),
        light: alpha('#2E7D32', 0.5),
        dark: alpha('#2E7D32', 0.9),
        contrastText: getContrastRatio('#2E7D32', '#fff') > 4.5 ? '#fff' : '#111',
    },
    darkGreen: {
        main: '#27862dff',
        light: alpha('#27862dff', 0.5),
        dark: alpha('#27862dff', 0.9),
        contrastText: getContrastRatio('#27862dff', '#fff') > 4.5 ? '#fff' : '#111',
    },
    lightGreen: {
        main: '#a8e2aaff',
        light: alpha('#a8e2aaff', 0.5),
        dark: alpha('#a8e2aaff', 0.9),
        contrastText: '#fff'
    }
  },
  components: {
    MuiTableRow: {
      styleOverrides: {        
        root: ({ theme }) => ({          
          'thead &': {
            backgroundColor: theme.palette.primary.light,
            '& th': {
              color: '#ffffff',
              fontWeight: 'bold',
            },
          },
          'tbody &:hover': {            
            backgroundColor: theme.palette.action.hover, 
          },
        }),
      },
    },
  },
});

export default theme;